import axios from 'axios';
import { DEMO_MODE } from './demoMode';

// Sanctum SPA auth: cookie-based, so every request must carry credentials.
// No bearer token is ever stored in localStorage/sessionStorage.
const apiOrigin = import.meta.env.VITE_API_ORIGIN || 'http://localhost:8000';

export const axiosInstance = axios.create({
  baseURL: `${apiOrigin}/api/v1`,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
  },
});

/** Must be called before login/register — primes the XSRF-TOKEN cookie Sanctum needs for the session. No-op in demo mode (no backend to talk to). */
export async function ensureCsrfCookie() {
  if (DEMO_MODE) return;
  await axios.get(`${apiOrigin}/sanctum/csrf-cookie`, { withCredentials: true });
}

export default axiosInstance;
